import { render, staticRenderFns } from "./midtermReview.vue?vue&type=template&id=6aea051e&scoped=true&"
import script from "./midtermReview.vue?vue&type=script&lang=js&"
export * from "./midtermReview.vue?vue&type=script&lang=js&"
import style0 from "./midtermReview.vue?vue&type=style&index=0&id=6aea051e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea051e",
  null
  
)

export default component.exports